import { FieldValues, UseFormSetValue } from "react-hook-form";
import { dateFormatYYYYspaceMMspaceDDspaceTimeAddMoreDays } from "src/shared/utilities/dateConvertions";

/**
 * function used to reset the create order form values
 * @param setValue this is a method from hookform
 */
export const resetTheCreateRequestFormFields = (
  setValue: UseFormSetValue<FieldValues>
) => {
  setValue("areas", "");
  setValue("title", "");
  setValue("description", "");
  setValue("categoryId", "");
  setValue("appointment", "");
};

/**
 * function used to handle the order completed date for single order
 * @param data order details response data
 * @returns completed date
 */
export const handleCompletedDate = (data: any) => {
  let completedDate = data?.DueDate;
  let isDue = true;

  if (data?.CompletedDate === undefined) {
    completedDate = data?.DueDate;
    isDue = false;
  } else if (data?.CompletedDate !== undefined) {
    completedDate = data?.CompletedDate;
    isDue = false;
  } else if (
    data?.CompletedDate !== undefined &&
    data?.StartedDate !== undefined &&
    data?.StartedDate > data?.DueDate
  ) {
    completedDate = dateFormatYYYYspaceMMspaceDDspaceTimeAddMoreDays(
      data?.StartedDate,
      4
    );
    completedDate = data?.CompletedDate;
    isDue = false;
  } else if (data?.DueDate === undefined) {
    completedDate = dateFormatYYYYspaceMMspaceDDspaceTimeAddMoreDays(
      data?.ReportedDate,
      4
    );
    completedDate = data?.CompletedDate;
    isDue = false;
  }

  return [completedDate, isDue];
};

export function delayApi(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Maps appointment API values to display values
 * @param appointmentValue The appointment value from API
 * @returns The display value for the appointment
 */
export const mapAppointmentToDisplayValue = (appointmentValue: string): string => {
  switch (appointmentValue) {
    case "Permission Given":
      return "Permission to enter given";
    case "Call":
      return "Call to schedule";
    default:
      return "Not Required";
  }
};

/**
 * Maps display values back to appointment API values
 * @param displayValue The display value from the form
 * @returns The API value for the appointment
 */
export const mapDisplayToAppointmentValue = (displayValue: string): string => {
  switch (displayValue) {
    case "Permission to enter given":
      return "Permission Given";
    case "Call to schedule":
      return "Call";
    default:
      return "Call"; // Default fallback
  }
};
